import { createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../../Common/Interceptors/AxiosConfig";

const initialState = {
    errors:null,
    isLoading:false,
    isSuccess:false,
    taskList:[],
    message:null,
};

const TaskSlice = createSlice({
    name:"tasks",
    initialState,
    reducers:{
        setErrors:(state, action) =>{
            state.errors = action.payload;
        },
        setLoading: (state, action) => {
           state.isLoading = action.payload;
        },
        setSuccess:(state, action) =>{
            state.isSuccess = action.payload;
        },
        setTaskLists:(state, action) =>{
            state.taskList = action.payload
        },
        setMessage:(state, action) =>{
            state.message = action.payload
        }
    }
});

// ✅ OPTIMIZED: Fetch available Services (not yet added to service)
// Endpoint: GET /serviceProvider/:serviceId/subservices/available
// ✅ OPTIMIZED: Added caching to prevent unnecessary API calls
export const getTaskList = (serviceId) => async (dispatch, getState)=>{
    if (!serviceId) {
        dispatch(setErrors({message: 'Service ID is required'}));
        return;
    }

    // ✅ OPTIMIZED: Check if we already have data cached (avoid duplicate calls)
    const state = getState();
    const cachedList = state.tasks?.taskList || [];
    
    // If we have cached data, skip API call (prevents re-fetching when modal reopens)
    if (cachedList.length > 0) {
        return;
    }

    dispatch(setLoading(true));
    dispatch(setErrors(null));
    try{
        // ✅ CORRECT ENDPOINT: /serviceProvider/:serviceId/subservices/available
        let URL = `/serviceProvider/${serviceId}/subservices/available`;
        const response = await axiosInstance.get(URL);
        const {status, data} = response?.data || {};
        if(status === "success"){
            // ✅ OPTIMIZED: Transform Services efficiently
            const transformedData = (data || []).map(service => ({
                ...service,
                id: service._id || service.id,
                _id: service._id || service.id,
                name: service.name,
                description: service.description,
                icon: service.icon,
                completionTime: service.completionTime,
            }));
            dispatch(setTaskLists(transformedData));
            dispatch(setSuccess(true));
        }

    }catch(error){
        
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(setErrors({message:errMsg}));
    }
    dispatch(setLoading(false));
}

export const addTaskPrice =(body) => async (dispatch) =>{
    dispatch(setLoading(true));
    dispatch(setErrors(null));
    try{
        let URL ='/serviceprovider/task/price';
        const response = await axiosInstance.post(URL,body);
        const { status} = response?.data || {};
        if(status === "success"){
            dispatch(setSuccess(true));
        }
    }catch(error){
        const errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
        dispatch(setErrors({ message: errorMsg }));
    }
        dispatch(setLoading(false));
};

// ✅ FIXED: Add Service to Service (price optional - can be set later)
// Endpoint: POST /serviceProvider/:serviceId/subservices
// Body: { serviceId, price (optional), priceType, currency }
export const addTastToService = (body) =>async (dispatch) =>{
    dispatch(setLoading(true));
    dispatch(setErrors(null));
    try{
        // ✅ FIXED: Use serviceId (not serviceServiceId)
        // ✅ Price is now optional - defaults to 0, user can set price later
        const { serviceId, price, priceType = 'fixed' } = body;
        
        if (!serviceId) {
            throw new Error('Service ID is required');
        }

        // ✅ CORRECT ENDPOINT: /serviceProvider/:serviceId/subservices
        // ✅ CORRECT FIELD: serviceId (not serviceServiceId)
        // ✅ Price is optional - backend will default to 0 if not provided
        let URL = `/serviceProvider/${serviceId}/subservices`;
        const requestBody = {
            serviceId: serviceId,
            priceType: priceType || 'fixed',
            currency: 'INR'
        };
        
        // Only include price if provided and valid
        if (price && parseFloat(price) > 0) {
            requestBody.price = parseFloat(price);
        }
        
        const response = await axiosInstance.post(URL, requestBody);
        
        const { status, message } = response?.data || {};
        if (status === "success") {
            dispatch(setMessage(message || "Service added successfully"));
            dispatch(setSuccess(true));
            dispatch(setLoading(false));
        }else {
            const errorMsg = message || "Failed to add Service to service";
            dispatch(setErrors({ message: errorMsg }));
            dispatch(setLoading(false));
        }

    }catch(error){
        
        const errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
        dispatch(setErrors({ message: errorMsg }));
        dispatch(setLoading(false));
    }
}


export const {
  setErrors,
  setLoading,
  setSuccess,
  setTaskLists,
  setMessage
} = TaskSlice.actions;

export default TaskSlice.reducer;